import React, { useContext } from "react";
import { useNavigate } from "react-router-dom";
import { Box, IconButton, Typography } from "@mui/material";
import LogoutIcon from "@mui/icons-material/Logout";
import TkBasicHeader from "../BasicHeader";
import TkButton from "../../../../../atoms/TkButton";
import { TkHeaderProps } from "../../../../../../type/componentsType/TkHeaderType";
import "../BasicHeader/_style.scss";
import { GlobalContext } from "../../../../../../context/globalContext";
import { BusinessContext } from "../../../../../../context/businessContext";

/**
 * ヘッダー部品（機構）
 * ユーザータイプが機構の場合のページのヘッダー
 * @param {number} sideBarWidth サイドバーの表示幅
 * @param {string} headerName ヘッダー名
 * @param {string} department 所属部署名
 * @param {boolean} hideButton ボタンを非表示にするかどうか
 * @param {string} userType ユーザータイプ
 * @return TkHeader ヘッダー部品（機構）
 */
export const TkKikoHeader: React.FC<TkHeaderProps> = (props) => {
  const { sideBarWidth, department, hideButton, userType, headerName } = props;

  const navigate = useNavigate();
  const { setState } = useContext(GlobalContext);
  const { setState: setBusinessStete } = useContext(BusinessContext);

  return (
    <Box data-testid="tkKikoHeader">
      <TkBasicHeader sideBarWidth={sideBarWidth} userType={userType}>
        <TkBasicHeader.Slot slot="right">
          {!hideButton && (
            <>
              <Box className="headerLink">
                {headerName}　様
              </Box>


              <Typography className="headerDept">所属：{department}</Typography>

              <TkButton className="helpButton" onClick={() => {
                navigate("/SCRW020001");
              }}>ヘルプ</TkButton>

              <IconButton
                onClick={() => {
                  setState({});
                  setBusinessStete({});
                  navigate("/");
                }}
                data-testid="logoutIcon"
              >
                <LogoutIcon />
              </IconButton>
            </>
          )}
        </TkBasicHeader.Slot>
      </TkBasicHeader>
    </Box>
  );
};

export default TkKikoHeader;
